<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">Pilih Pindah Gudang</h5>
            </b-card-header>
            <b-card-body>
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/pindah-gudangs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="gudang-asal" slot-scope="props">
                            <span>
                                {{ props.rowData.gudang_asal.name }}
                            </span>
                        </template>
                        <template slot="gudang-tujuan" slot-scope="props">
                            <span>
                                {{ props.rowData.gudang_tujuan.name }}
                            </span>
                        </template>
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.status == 'Pengiriman'" class="badge badge-pill badge-warning">{{ props.rowData.status }}</span>
                            <span v-else-if="props.rowData.status == 'Pending Pengirim'" class="badge badge-pill badge-danger">{{ props.rowData.status }}</span>
                            <span v-else-if="props.rowData.status == 'Selesai'" class="badge badge-pill badge-success">{{ props.rowData.status }}</span>
                            <span v-else>-</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" :disabled="isSelected(props.rowData.id)" title="Pilih" @click="select(props.rowData)" class="btn btn-primary text-nowrap"><i class="fas fa-check"></i> Pilih</button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';

export default {
    name: "pindah-gudang-selector",

    props: {
        selected: {
            type: Array,
            default: [],
        },

        isAll: {
            type: Boolean,
            default: null,
        },
    },

    components: {
        SearchBar,
    },

    mixins: [VuetableMixin],

    data() {
        return {
            perPage: 10,
            currentPindahGudang: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchGudangAsalId: '',
            searchGudangTujuanId: '',
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'tanggal_berangkat',
                    title: 'Tanggal Berangkat',
                    sortField: 'tanggal_berangkat',
                    callback: 'formatDate',
                },
                {
                    name: 'penerimaan.created_at',
                    title: 'Tanggal Tiba',
                    sortField: 'tanggal_tiba',
                    callback: 'formatDate',
                },
                {
                    name: '__slot:gudang-asal',
                    title: 'Gudang Asal',
                    sortField: 'gudang_asal_name',
                },
                {
                    name: '__slot:gudang-tujuan',
                    title: 'Gudang Tujuan',
                    sortField: 'gudang_tujuan_name',
                },
                {
                    name: 'bobot_berangkat',
                    title: 'Berat Berangkat (kg)',
                    callback: 'formatNumber',
                },
                {
                    name: 'bobot_tiba',
                    title: 'Berat Tiba (kg)',
                    callback: 'formatNumber',
                },
                {
                    name: 'total_biaya',
                    title: 'Biaya',
                    sortField: 'total_biaya',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:status',
                    title: 'Status',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                gudang_asal_id: this.searchGudangAsalId,
                gudang_tujuan_id: this.searchGudangTujuanId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchGudangAsalId = search.searchGudangAsalId;
            this.searchGudangTujuanId = search.searchGudangTujuanId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchGudangAsalId = '';
            this.searchGudangTujuanId = '';
            this.refresh();
        },

        isSelected(id) {
            return this.selected.find(pindahGudang => pindahGudang.id == id);
        },

        select(data) {
            this.$emit('selected', data);
        },
    },
}
</script>
